/* @flow */

export const formatNullable = (value: mixed): string => {
  if (value === null || value === undefined) {
    return '—';
  }

  const asString = String(value);
  return asString === '' ? '—' : asString;
};

export const formatCount = (count: number): string => count.toLocaleString();

export const formatFieldLabel = (field: string): string =>
  field.replace(/_/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase());
